var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _ellipse, _path2, _path3, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReqApproved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 71,
    viewBox: "0 0 73 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M41.215 1.00613C36.3563 2.25224 32.2841 5.09824 29.8018 9.46485C27.7597 13.0575 26.5658 17.222 23.6492 20.2672C20.5421 23.511 18.021 25.2095 13.6274 25.7124C-2.39379 27.5471 -1.75505 53.8667 13.2329 64.3425C28.2209 74.8183 60.5637 73.4314 69.8986 43.0901C79.2334 12.7488 65.5612 4.49872 54.3196 1.22513C50.2285 0.0335123 45.5176 -0.0972927 41.215 1.00613Z",
    fill: "#B7CCFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.3527,
    y: 10.4766,
    width: 45.307,
    height: 52.7692,
    rx: 2.95389,
    fill: "#3A6EEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5125,
    y: 12.625,
    width: 40.9921,
    height: 48.4615,
    rx: 2.95389,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1361,
    y: 29.3203,
    width: 16.9851,
    height: 0.738462,
    rx: 0.369231,
    fill: "#081E54"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1361,
    y: 33.0156,
    width: 16.9851,
    height: 0.738462,
    rx: 0.369231,
    fill: "#081E54"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1361,
    y: 36.7031,
    width: 16.9851,
    height: 0.738462,
    rx: 0.369231,
    fill: "#081E54"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1361,
    y: 40.3984,
    width: 16.9851,
    height: 0.738462,
    rx: 0.369231,
    fill: "#081E54"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.0155,
    cy: 11.0661,
    rx: 10.7874,
    ry: 10.7693,
    fill: "#00B479"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8352 7.53125L37.9922 14.8229",
    stroke: "white",
    strokeWidth: 1.03716,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9922 14.8229L35.0707 11.9062",
    stroke: "white",
    strokeWidth: 1.03716,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.53614 54.4619C4.06798 54.4619 3.68727 54.0813 3.68729 53.6114L3.68746 46.3028C3.68748 45.8337 4.06731 45.4531 4.53636 45.4531C5.00541 45.4531 5.38436 45.8337 5.38434 46.3028L5.38417 53.6122C5.38415 54.0813 5.00431 54.4628 4.53614 54.4628L4.53614 54.4619Z",
    fill: "#00B479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14593 50.8564H0.850529C0.382365 50.8564 0.00166163 50.4758 0.00167306 50.0059C0.00168449 49.5359 0.381523 49.1562 0.85057 49.1562H8.14597C8.61413 49.1562 8.99484 49.5368 8.99483 50.0059C8.99481 50.4749 8.61498 50.8564 8.14593 50.8564Z",
    fill: "#00B479"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.7443 26.6342C68.4305 26.6342 68.1763 26.3818 68.1763 26.0703L68.1764 21.2202C68.1764 20.9087 68.4306 20.6562 68.7444 20.6562C69.0582 20.6562 69.3124 20.9087 69.3124 21.2202L69.3123 26.0703C69.3123 26.3818 69.058 26.6342 68.7443 26.6342Z",
    fill: "#00B479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1881 24.206H66.3028C65.9891 24.206 65.7348 23.9536 65.7348 23.642C65.7349 23.3305 65.9891 23.0781 66.3029 23.0781H71.1881C71.5019 23.0781 71.7561 23.3305 71.7561 23.642C71.7561 23.9536 71.5018 24.206 71.1881 24.206Z",
    fill: "#00B479"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReqApproved);
export default __webpack_public_path__ + "static/media/ReqApproved.80a2562e1f9e81e6c1412cb8c3c10652.svg";
export { ForwardRef as ReactComponent };